<template>
  <form-field :id="id" :title="title" :show-label="showLabel" :error-message="errorMessage">
    <template #info>
      <slot name="info" />
    </template>
    <template #postInfo>
      <slot name="postInfo" />
    </template>
    <div :class="[$style.wrapper, wrapperClass]">
      <select
        :id="id"
        :name="id"
        :tabindex="tabindex"
        :data-qa="dataQa"
        :disabled="isReadOnly || null"
        @keydown.enter.prevent="tabOnEnter && nextField($event.target)"
        @input="$emit('update:modelValue', $event.target.value)"
        @change="onChange($event)"
      >
        <option v-if="noValueText" :value="null" :selected="modelValue === null">
          {{ noValueText }}
        </option>
        <option
          v-for="option in options"
          :key="option.value"
          :value="option.value"
          :selected="option.value === modelValue"
        >
          {{ option.name }}
        </option>
      </select>
      <icon v-if="!isReadOnly" icon="dropdown" :tabindex="-1" />
    </div>
  </form-field>
</template>

<script>
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import FormField from '@/components/generic/presentational/atoms/formField/FormField.vue'
import TabOnEnter from '@/mixins/tabOnEnter.js'

export default {
  components: {
    Icon,
    FormField,
  },
  mixins: [TabOnEnter],
  props: {
    id: {
      type: String,
      required: true,
    },
    wrapperClass: {
      type: String,
      required: false,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    modelValue: {
      type: String,
      required: false,
      default: '',
    },
    errorMessage: {
      type: String,
      default: '',
    },
    noValueText: {
      type: String,
      default: '',
    },
    dataQa: {
      type: String,
      default: null,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    nullValueOnEmpty: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['change', 'update:modelValue'],
  methods: {
    onChange($event) {
      const value = $event.target.value
      this.$emit('change', !value && this.nullValueOnEmpty ? null : $event.target.value)
    },
  },
}
</script>

<style scoped module lang="scss">
.wrapper {
  position: relative;

  &::before {
    $margin: 2px;

    content: '';
    position: absolute;
    top: $margin;
    right: $margin;
    bottom: $margin;
    background: $white;
    width: 2em;
    pointer-events: none;
  }

  select {
    &[disabled] {
      -webkit-appearance: none;
      -moz-appearance: none;
    }
  }
}

svg {
  @include icon(0.5em);

  position: absolute;
  right: 1em;
  top: 50%;
  margin-top: -0.2em;
  pointer-events: none;
}
</style>
